import { FileCheck, Clock, CheckCircle, Users } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { ComingSoonWatermark } from '@/components/ComingSoonWatermark';
import { useNavigation } from '@/contexts/NavigationContext';
import { cn } from '@/lib/utils';

export function PoliciesPage() {
  const { sectionColor } = useNavigation();

  return (
    <div className="space-y-6">
      <ComingSoonWatermark
        pageKey="policy-management"
        icon={FileCheck}
        title="Policy Management Coming Soon"
        description="Comprehensive policy lifecycle management with versioning, approval workflows, and attestation tracking will be available soon."
      />
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className={cn("text-3xl font-bold", sectionColor)}>Policy Management</h1>
          <p className="text-neutral-400 mt-1">
            Manage organizational policies, versions, and attestations
          </p>
        </div>
        <button className="btn-primary">
          Create Policy
        </button>
      </div>

      {/* Metrics Strip */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Total Policies</p>
              <p className="text-2xl font-bold text-white mt-1">48</p>
            </div>
            <div className="p-3 bg-primary-500/20 rounded-lg">
              <FileCheck className="text-primary-400" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Published</p>
              <p className="text-2xl font-bold text-success-500 mt-1">42</p>
            </div>
            <div className="p-3 bg-success-500/20 rounded-lg">
              <CheckCircle className="text-success-500" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Review Due</p>
              <p className="text-2xl font-bold text-warning-500 mt-1">6</p>
            </div>
            <div className="p-3 bg-warning-500/20 rounded-lg">
              <Clock className="text-warning-500" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Attestations</p>
              <p className="text-2xl font-bold text-white mt-1">1,247</p>
            </div>
            <div className="p-3 bg-primary-500/20 rounded-lg">
              <Users className="text-primary-400" size={24} />
            </div>
          </div>
        </Card>
      </div>

      {/* Policies Table */}
      <Card className="p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Published Policies</h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-neutral-800">
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Policy</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Version</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Owner</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Last Updated</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-neutral-800/50 hover:bg-neutral-900/50">
                <td className="py-3 px-4 text-sm text-white">Information Security Policy</td>
                <td className="py-3 px-4 text-sm font-mono text-primary-400">v3.2</td>
                <td className="py-3 px-4 text-sm text-neutral-300">Security Team</td>
                <td className="py-3 px-4 text-sm text-neutral-300">2024-09-15</td>
                <td className="py-3 px-4"><span className="badge-success">Published</span></td>
              </tr>
              <tr className="border-b border-neutral-800/50 hover:bg-neutral-900/50">
                <td className="py-3 px-4 text-sm text-white">Data Protection & Privacy Policy</td>
                <td className="py-3 px-4 text-sm font-mono text-primary-400">v2.1</td>
                <td className="py-3 px-4 text-sm text-neutral-300">Compliance Team</td>
                <td className="py-3 px-4 text-sm text-neutral-300">2024-08-22</td>
                <td className="py-3 px-4"><span className="badge-warning">Review Due</span></td>
              </tr>
              <tr className="hover:bg-neutral-900/50">
                <td className="py-3 px-4 text-sm text-white">Third-Party Risk Management</td>
                <td className="py-3 px-4 text-sm font-mono text-primary-400">v1.5</td>
                <td className="py-3 px-4 text-sm text-neutral-300">Risk Team</td>
                <td className="py-3 px-4 text-sm text-neutral-300">2024-10-10</td>
                <td className="py-3 px-4"><span className="badge-success">Published</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
